import { cn } from "@/utils/cn";

interface IPulseProps {
  className?: string;
}

const Pulse = ({ className }: IPulseProps) => <div className={cn("animate-pulse rounded-lg bg-default-200 dark:bg-default-100", className)} />;

export default Pulse;
